module.exports = __webpack_public_path__ + "img/arrow-down-square-triangle.4544aa63.svg";